import React, { Component } from 'react';
import styles from './index.css';
import fonts from '../../../iconfonts.css';
import {observer} from 'mobx-react';
import FontAwesome from 'react-fontawesome';
import {date} from '../../stores/index'

@observer
export default class Weather extends Component {

    showWeather(weather){
        switch (weather){
            case 0:
                return fonts.iconSunny;
            case 1:
                return fonts.iconRain;
            case 2:
                return fonts.iconCloudy;
            default:
                break;
        }
    }

    render(){
        return(
            <div className={styles.container}>
                <div className={styles.item + ' ' + styles.dateTimeWeather}>
                    <div className={styles.currentDate}>{date.day.toLocaleString("uk", {month: 'long', day: 'numeric'})}</div>
                    <div className={styles.currentTime}>{this.props.time.getTime}</div>
                    <div className={styles.currentWeather}>
                        {date.weather === 0 ? 'Сонячно'
                        : date.weather === 1 ? 'Сильні опади'
                        : 'Хмарно'}
                    </div>
                    <div className={styles.currentTemperature}><span>{date.temp.min}-{date.temp.max}</span> &deg;C</div>
                    <div className={styles.currentWeatherIcon}><i className={this.showWeather(date.weather)}></i></div>
                </div>

                <div className={styles.item + ' ' + styles.weatherForecast}>
                    <div className={styles.subWeatherContainer}>
                        {date.forecast.map((item,i)=>{
                            return(
                                <div className={styles.subWeatherItem} key={i}>
                                    <div className={styles.subWeatherItemDate}>{`${date.day.getDate()+i+1}.${date.day.getMonth() < 10 ? '0' + date.day.getMonth() : date.day.getMonth()}.${date.day.getFullYear()}`}</div>
                                    <div className={styles.subWeatherItemIcon}>
                                        <i className={this.showWeather(item.weather)}></i>
                                    </div>
                                    <div className={styles.subWeatherItemTemp}>{item.temp.min}-{item.temp.max} &deg;C</div>
                                </div>
                            )
                        })}
                    </div>
                    {/*<div className={styles.getForecast}>*/}
                        {/*<a>Прогноз на тиждень&nbsp;&nbsp;&nbsp;<FontAwesome className={styles.inTextIcon} name='arrow-circle-right' /></a>*/}
                    {/*</div>*/}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/Weather/index.js